import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
// import CardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Carousel from './Carousel'
import Collapse from '@mui/material/Collapse';
// import IconButton from '@mui/material/IconButton';

import { IoIosArrowDown } from "react-icons/io";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IoIosArrowDown {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));


export default function MediaCard({key, carouselId, type ,img1, img2, img3, title, desc, frameworks}) {
  
const [expanded, setExpanded] = React.useState(false);

const handleExpandClick = () => {
  setExpanded(!expanded);
};
  return (
    <Card sx={{ backgroundColor: '#0A4D68'}} className={`mb-4 ${ type === "web-app" ? "webApp-card" : "landingPage-card"} `}>

      <Carousel carouselId={carouselId} type={type} img1={img1} img2={img2} img3={img3} />

      <CardContent>
        <Typography gutterBottom variant="h5" component="div" sx={{textAlign: "center", color: "#e6f1ff", fontSize: "16px"}}>
          {title}
        </Typography>
      </CardContent>
      {type === "web-app" &&
      (
        <React.Fragment>
      <CardActions disableSpacing>
      <Typography variant="h6" component="div" sx={{textAlign: "start", color: "#00FFCA", fontSize: "14px"}}>
        More
      </Typography>
      <ExpandMore
        expand={expanded}
        onClick={handleExpandClick}
        aria-expanded={expanded}
        aria-label="show more"
        sx={{textAlign: "start", color: "#00FFCA", cursor: "grab"}}
      >
        <ExpandMoreIcon />
      </ExpandMore>
    </CardActions>
    <Collapse in={expanded} timeout="auto" unmountOnExit>
      <CardContent>
        <Typography sx={{textAlign: "justify", color: "#e6f1ff"}}>
        {desc}
        </Typography>
        <h6 style={{ color:"#00FFCA"}}>Frameworks:</h6>
        <Typography variant="h6" component="div" sx={{textAlign: "start", color: "cornsilk",fontSize: "13px"}}>
        {frameworks}
      </Typography>
      <Typography sx={{textAlign: "start", color: "#e6f1ff"}}>
       
      </Typography>
      </CardContent>
    </Collapse>
    </React.Fragment>
      
      )
      
      }

    </Card>
  );
}